"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFound = void 0;
const ApiException_1 = require("./ApiException");
class NotFound extends ApiException_1.ApiException {
    constructor(message = 'Not Found.', data) {
        super(message, data);
    }
}
exports.NotFound = NotFound;
